import React, { useEffect, useState } from 'react';
import { Linking, Pressable, PressableProps } from 'react-native';
import useStyles from '../../../hooks/styles-hook';
import Label, { LabelType } from '../../common/Label';
import useMyAccountActions from '../../../hooks/myAccountActions-hook';

import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-native-fontawesome';
import { useNavigation } from '@react-navigation/native';
import type { MyAccountRouteName } from '../../../models/NavigationElements';
import { rootNavigate } from '../../../navigation/rootNavigation';

export interface MenuItemProps extends PressableProps {
  title: string;
  action?: MyAccountRouteName | null;
  bottomLine?: boolean;
  forwardProps?: any;
  labelType?: LabelType;
  icon?: IconProp;
  mirrorIcon?: boolean;
  externalLink?: string;
  trailingLabel?: string;
}

const MenuItem = (props: MenuItemProps) => {
  const styles = useStyles((section) => section.myAccount);
  const myAccountActions = useMyAccountActions();
  const navigation = useNavigation();

  const [action, setAction] = useState(props.action);
  const [externalLink, setExternalLink] = useState(props.externalLink);
  const bottomLine = props.bottomLine ?? {};

  useEffect(() => {
    setAction(props.action);
  }, [props.action]);

  useEffect(() => {
    setExternalLink(props.externalLink);
  }, [props.externalLink]);

  const handleClick = () => {
    if (action) {
      myAccountActions.setProps(props.forwardProps);
      navigation.navigate(action as never);
      return;
    } else {
      if (externalLink) {
        Linking.openURL(externalLink);
        return;
      }
    }

    // LOGOUT DISPATCH HERE
    myAccountActions.setVisibility(false);
    rootNavigate('logout');
  };

  return (
    <Pressable {...props} accessibilityRole="button" accessibilityLabel={props.accessibilityLabel ?? `${props.title}${props.trailingLabel ? `, ${props.trailingLabel}` : ''}`}
      style={[styles.menuItem, { ...bottomLine }]} onPress={handleClick}>
      {props.icon && <FontAwesomeIcon icon={props.icon} style={[styles.menuItem.icon, props.mirrorIcon ? styles.menuItem.icon.mirror : {}]} />}
      <Label variant={props.labelType ?? LabelType.myAccountLink} numberOfLines={0}
        style={props.trailingLabel ? { flex: 1, minWidth: 0 } : undefined}>{props.title}</Label>
      {props.trailingLabel && <Label variant={props.labelType ?? LabelType.myAccountLink}
        style={{ marginLeft: 'auto', paddingLeft: 8, fontSize: 13, fontWeight: '600', flexShrink: 0 }}>{props.trailingLabel}</Label>}
    </Pressable>
  );
};

export default MenuItem;
